import React from 'react';
import { useCandidatesOverviewContext } from '../Contexts/CandidatesOverviewContext/CandidatesOverviewContext';
import Dialogs from '../../components/dialogs/Dialogs';

function CandidateOverviewDialogs() {
    const { assessmentName } = useCandidatesOverviewContext();

    return <Dialogs assessmentName={assessmentName} />;
}

export default CandidateOverviewDialogs;
